import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { businessAPI, campaignAPI } from '../services/api';
import './Dashboard.css';

function Dashboard() {
  const [stats, setStats] = useState({
    totalBusinesses: 0,
    totalCampaigns: 0,
    activeCampaigns: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [businessesRes, campaignsRes] = await Promise.all([
        businessAPI.getAll({ limit: 1 }),
        campaignAPI.getAll()
      ]);

      const activeCampaigns = campaignsRes.data.data.filter(
        c => c.status === 'sending' || c.status === 'scheduled'
      ).length;

      setStats({
        totalBusinesses: businessesRes.data.total || 0,
        totalCampaigns: campaignsRes.data.count || 0,
        activeCampaigns
      });
    } catch (error) {
      console.error('İstatistikler yüklenemedi:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="dashboard">
        <h1>Dashboard</h1>

        {loading ? (
          <div className="loading">Yükleniyor...</div>
        ) : (
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">🏢</div>
              <div className="stat-info">
                <h3>{stats.totalBusinesses}</h3>
                <p>Toplam İşletme</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">📢</div>
              <div className="stat-info">
                <h3>{stats.totalCampaigns}</h3>
                <p>Toplam Kampanya</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">🚀</div>
              <div className="stat-info">
                <h3>{stats.activeCampaigns}</h3>
                <p>Aktif Kampanya</p>
              </div>
            </div>
          </div>
        )}

        <div className="quick-actions">
          <h2>Hızlı İşlemler</h2>
          <div className="actions-grid">
            <a href="/businesses" className="action-card">
              <div className="action-icon">🔍</div>
              <h3>İşletme Ara</h3>
              <p>Google Maps'ten işletme verisi topla</p>
            </a>

            <a href="/campaigns" className="action-card">
              <div className="action-icon">✉️</div>
              <h3>Kampanya Oluştur</h3>
              <p>Toplu mesaj gönderimi başlat</p>
            </a>

            <a href="/settings" className="action-card">
              <div className="action-icon">⚙️</div>
              <h3>Ayarlar</h3>
              <p>Mesajlaşma servisleri yapılandır</p>
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Dashboard;